var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2408 0.599609H1.84077C0.850772 0.599609 0.0407715 1.40961 0.0407715 2.39961V16.7996C0.0407715 17.7896 0.850772 18.5996 1.84077 18.5996H16.2408C17.2308 18.5996 18.0408 17.7896 18.0408 16.7996V2.39961C18.0408 1.40961 17.2308 0.599609 16.2408 0.599609ZM5.44077 15.8996H2.74077V7.79961H5.44077V15.8996ZM4.09077 6.26961C3.19077 6.26961 2.47077 5.54961 2.47077 4.64961C2.47077 3.74961 3.19077 3.02961 4.09077 3.02961C4.99077 3.02961 5.71077 3.74961 5.71077 4.64961C5.71077 5.54961 4.99077 6.26961 4.09077 6.26961ZM15.3408 15.8996H12.6408V11.1296C12.6408 10.4096 12.0108 9.77961 11.2908 9.77961C10.5708 9.77961 9.94077 10.4096 9.94077 11.1296V15.8996H7.24077V7.79961H9.94077V8.87961C10.3908 8.15961 11.3808 7.61961 12.1908 7.61961C13.9008 7.61961 15.3408 9.05961 15.3408 10.7696V15.8996Z",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_709"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.0407715 0.599609)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedin);
export default __webpack_public_path__ + "static/media/icon-linkedin.4b3979fd482ed2e947d93422102dde88.svg";
export { ForwardRef as ReactComponent };